// src/component/BottomNav.js
import React from 'react';
// Import FaListAlt for the History tab
import { FaHome, FaComment, FaShoppingCart, FaUser, FaSignOutAlt, FaListAlt } from 'react-icons/fa';

// *** UPDATED: Add cartItemCount and historyActionCount props ***
const BottomNav = ({
  activeTab,
  setActiveTab,
  onLogoutClick,
  cartItemCount = 0, // Default to 0 if not provided
  historyActionCount = 0 // Default to 0 if not provided
}) => {
  return (
    <nav className="bottom-nav">
      {/* Home Button */}
      {/* *** UPDATED: Added nav-button-wrapper class for consistency *** */}
      <button
        className={`nav-button-wrapper ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => setActiveTab('home')}
        aria-label="Home"
        title="Home"
      >
        <FaHome />
        {/* <span className="nav-label">Home</span> */}
      </button>

      {/* === HISTORY BUTTON with Badge === */}
      {/* *** UPDATED: Added nav-button-wrapper, updated aria-label, added badge span *** */}
      <button
        className={`nav-button-wrapper ${activeTab === 'history' ? 'active' : ''}`} // Use wrapper class
        onClick={() => setActiveTab('history')}
        aria-label={`Application History ${historyActionCount > 0 ? `(${historyActionCount} items need action)` : ''}`} // Dynamic aria-label
        title="History"
      >
        <FaListAlt />
        {/* Conditionally render the badge */}
        {historyActionCount > 0 && (
          <span className="notification-badge">{historyActionCount > 9 ? '9+' : historyActionCount}</span> // Cap at 9+
        )}
      </button>
      {/* ================================ */}

      {/* Chat Button */}
      {/* *** UPDATED: Added nav-button-wrapper class for consistency *** */}
      <button
        className={`nav-button-wrapper ${activeTab === 'chat' ? 'active' : ''}`}
        onClick={() => setActiveTab('chat')}
        aria-label="Chat"
        title="Chat"
      >
        <FaComment />
        {/* <span className="nav-label">Chat</span> */}
      </button>

      {/* === CART BUTTON with Badge === */}
      {/* *** UPDATED: Added nav-button-wrapper, updated aria-label, added badge span *** */}
      <button
        className={`nav-button-wrapper ${activeTab === 'cart' ? 'active' : ''}`} // Use wrapper class
        onClick={() => setActiveTab('cart')}
        aria-label={`Cart ${cartItemCount > 0 ? `(${cartItemCount} items)` : ''}`} // Dynamic aria-label
        title="Cart"
      >
        <FaShoppingCart />
        {/* Conditionally render the badge */}
        {cartItemCount > 0 && (
          <span className="notification-badge">{cartItemCount > 9 ? '9+' : cartItemCount}</span> // Cap at 9+
        )}
      </button>
      {/* =========================== */}

      {/* Profile Button */}
      {/* *** UPDATED: Added nav-button-wrapper class for consistency *** */}
      <button
        className={`nav-button-wrapper ${activeTab === 'profile' ? 'active' : ''}`}
        onClick={() => setActiveTab('profile')}
        aria-label="Profile"
        title="Profile"
      >
        <FaUser />
        {/* <span className="nav-label">Profile</span> */}
      </button>

      {/* Logout Button */}
      {/* *** UPDATED: Added nav-button-wrapper class for consistency *** */}
      <button
        className="nav-button-wrapper" // Use wrapper class
        onClick={onLogoutClick}
        aria-label="Logout"
        title="Logout"
      >
        <FaSignOutAlt />
        {/* <span className="nav-label">Logout</span> */}
      </button>

      {/* Use inline styles or preferably move to a CSS file/module */}
      <style jsx>{`
        .bottom-nav {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          background-color: #ffffff;
          border-top: 1px solid #e0e4ec;
          padding: 8px 0;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 100;
          box-shadow: 0 -2px 5px rgba(0,0,0,0.05);
        }

        /* --- Style for the button wrapper needed for positioning the badge --- */
        /* *** UPDATED: Replaced 'button' styles with '.nav-button-wrapper' *** */
        .nav-button-wrapper {
          position: relative; /* Crucial for absolute positioning of the badge */
          background: none;
          border: none;
          font-size: 1.3rem;
          color: #5f6368;
          cursor: pointer;
          padding: 10px 8px;
          transition: color 0.2s ease-in-out;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2px;
          flex-grow: 1;
          flex-basis: 0;
          text-align: center;
        }
        /* --- End button wrapper style --- */

        /* Style for optional text labels */
        .nav-label {
            font-size: 0.65rem;
            margin-top: 2px;
            font-weight: 500;
            display: none; /* Optionally hide labels by default */
        }

        /* Apply active/hover directly to the wrapper */
        /* *** UPDATED: Targeting '.nav-button-wrapper' *** */
        .nav-button-wrapper.active {
          color: #1a73e8;
        }

        /* General hover (exclude logout) */
         /* *** UPDATED: Targeting '.nav-button-wrapper' *** */
        .nav-button-wrapper:hover:not([aria-label="Logout"]) {
            color: #1a73e8;
        }

        /* Logout specific hover */
        /* *** UPDATED: Targeting '.nav-button-wrapper' *** */
        .nav-button-wrapper[aria-label="Logout"]:hover {
             color: #a50e04;
        }


        /* --- Styles for the Notification Badge --- */
        /* *** ADDED: New styles for the badge *** */
        .notification-badge {
          position: absolute;
          top: 4px; /* Adjust as needed */
          right: 4px; /* Adjust as needed */
          /* Optional: Use transform for finer control if needed later */
          /* transform: translate(50%, -50%); */
          background-color: #d93025; /* Red color for notifications */
          color: white;
          font-size: 0.65rem; /* Small font size */
          font-weight: bold;
          border-radius: 50%; /* Make it circular */
          padding: 1px; /* Minimal padding */
          min-width: 16px; /* Ensure a minimum size */
          height: 16px; /* Ensure a minimum size */
          line-height: 14px; /* Vertically center text (adjust if needed) */
          text-align: center;
          box-shadow: 0 1px 2px rgba(0,0,0,0.2);
          pointer-events: none; /* Badge shouldn't interfere with clicks */
          z-index: 1; /* Ensure badge is above the icon if overlapping */
        }
        /* --- End Badge Styles --- */


        @media (max-width: 480px) {
            .nav-label {
                 /* display: none; */
            }
            /* *** UPDATED: Targeting '.nav-button-wrapper' *** */
            .nav-button-wrapper {
                 font-size: 1.2rem;
                 padding: 8px 4px;
            }
            /* *** ADDED: Responsive badge styles *** */
             .notification-badge {
                font-size: 0.6rem;
                min-width: 14px;
                height: 14px;
                line-height: 12px; /* Adjust if needed */
                top: 2px;
                right: 2px;
            }
        }

        /* Optional: Show labels on larger screens if hidden by default */
        @media (min-width: 481px) {
           .nav-label {
              /* display: block; */
           }
        }
      `}</style>
    </nav>
  );
};

export default BottomNav;